export const fieldNames = {
  lat: "latitude",
  long: "longitude",
};
